import DeleteOutlineIcon from '@material-ui/icons/DeleteOutline'
import StarIcon from '@material-ui/icons/Star'
import StarBorderIcon from '@material-ui/icons/StarBorder'
import ZoomInIcon from '@material-ui/icons/ZoomIn'
import styled from 'styled-components'

const Actions = styled.div`
  position: absolute;
  right: 8px;
  top: 8px;
  z-index: ${props => props?.theme?.zIndex?.mobileStepper};
`

const LeftActions = styled.div`
  position: absolute;
  left: 8px;
  top: 8px;
  z-index: ${props => props?.theme?.zIndex?.mobileStepper};
`

const ActionBox = styled.div`
  background: ${props => props.theme.palette.background.default};
  border-radius: 4px;
  margin-bottom: 8px;
  width: 24px;
  height: 24px;
  display: flex;
  justify-content: center;
  align-items: center;
`

const StyledZoomInIcon = styled(ZoomInIcon)`
  color: ${props => props.theme.palette.text.secondary};
  font-size: 24px;
`

const StyledStarIcon = styled(StarIcon)`
  color: ${props => props.theme.palette.primary.main};
  font-size: 24px;
`

const StyledStarBorderIcon = styled(StarBorderIcon)`
  color: ${props => props.theme.palette.text.secondary};
  font-size: 24px;
`

const StyledDeleteOutlineIcon = styled(DeleteOutlineIcon)`
  color: ${props => props.theme.palette.error.main};
  font-size: 24px;
`

export {
  Actions,
  LeftActions,
  ActionBox,
  StyledDeleteOutlineIcon,
  StyledZoomInIcon,
  StyledStarIcon,
  StyledStarBorderIcon,
}
